/* eslint-disable @typescript-eslint/no-explicit-any */

/* istanbul ignore next */
const regexMap = [
  {
    regex: /Home|Household/g,
    replaceValue: (useBuildingWord = false) =>
      useBuildingWord ? "Building" : "Business",
  },
  {
    regex: /home|household/g,
    replaceValue: (useBuildingWord = false) =>
      useBuildingWord ? "building" : "business",
  },
];

function replace(inputString: string, useBuildingWord: boolean) {
  let newInputString = inputString;

  regexMap.forEach((item) => {
    newInputString = newInputString.replace(
      item.regex,
      item.replaceValue(useBuildingWord)
    );
  });

  return newInputString;
}

export function switchWording(
  inputString: string,
  customerType: string,
  useBuildingWord = false
): string {
  if (customerType === "myself") return inputString;

  return replace(inputString, useBuildingWord);
}

export function switchWordingInObject(
  inputObject: Record<string, unknown>,
  customerType: string,
  useBuildingWord = false
): unknown {
  if (customerType === "myself") return inputObject;

  const newOptions = {};

  for (const key in inputObject) {
    /* istanbul ignore next */
    if (Object.prototype.hasOwnProperty.call(inputObject, key)) {
      (newOptions as any)[key] = {
        ...(inputObject as any)[key],
        text: replace((inputObject as any)[key].text, useBuildingWord),
        value: replace((inputObject as any)[key].value, useBuildingWord),
      };
    }
  }

  return newOptions;
}
